<template>
  <div class="text-left px-6 pb-12 bg-gray-50">
    <div class="absolute mt-11" @click="back">
      <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
    </div>
    <div class="text-center text-sm font-extrabold w-full pt-12">PAYMENT METHODS</div>
    <div class="pt-8 pb-6 text-xs">Choose a default payment method</div>
    <div class="pt-4" @click="pickUp">
      <div class="pr-5 inline-block">
        <naira-note-icon></naira-note-icon>
      </div>
      <div class="text-sm font-bold inline-block">Pay on Pick-up</div>
      <div class="float-right">
        <round-check-icon v-if="payment_type.pick_up"></round-check-icon>
        <div v-if="!payment_type.pick_up" class="rounded-2xl p-2 border border-nw-red"></div>
      </div>
    </div>
    <div class="pt-4" @click="byDelivery">
      <div class="pr-5 inline-block">
        <naira-note-icon></naira-note-icon>
      </div>
      <div class="text-sm font-bold inline-block">Pay on Delivery</div>
      <div class="float-right">
        <round-check-icon v-if="payment_type.delivery"></round-check-icon>
        <div v-if="!payment_type.delivery" class="rounded-2xl p-2 border border-nw-red"></div>
      </div>
    </div>
    <div class="pt-4" @click="withCard">
      <div class="pr-5 inline-block">
        <card-icon></card-icon>
      </div>
      <div class="text-sm font-bold inline-block">Pay with Card</div>
      <div class="float-right">
        <round-check-icon v-if="payment_type.card"></round-check-icon>
        <div v-if="!payment_type.card" class="rounded-2xl p-2 border border-nw-red"></div>
      </div>
    </div>
    <div class="border-b border-gray-100 pt-7"></div>
  </div>
</template>

<script>
import BackArrowIcon from '@/components/icons/BackArrowIcon.vue'
import CardIcon from '@/components/icons/CardIcon.vue'
import NairaNoteIcon from '@/components/icons/NairaNoteIcon.vue'
import RoundCheckIcon from '@/components/icons/RoundCheckIcon.vue'
export default {
  components: {
    BackArrowIcon,
    RoundCheckIcon,
    NairaNoteIcon,
    CardIcon
  },
  data() {
    return {
      promo_code: '',
      payment_type: {
        pick_up: false,
        delivery: false,
        card: false
      }
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'Dashboard'
      })
    },
    neutral() {
      this.payment_type.pick_up = false
      this.payment_type.delivery = false
      this.payment_type.card = false
    },
    pickUp() {
      this.neutral()
      this.payment_type.pick_up = true
    },
    byDelivery() {
      this.neutral()
      this.payment_type.delivery = true
    },
    withCard() {
      this.neutral()
      this.payment_type.card = true
    },
    next() {
      this.$emit('show-summary', true)
    }
  }
}
</script>

<style></style>
